define.alias("ember-cli-string-helpers/helpers/camelize", "preview-grid/helpers/camelize");